import { render, staticRenderFns } from "./academic_itso_refereesystem.vue?vue&type=template&id=aca1e120&scoped=true&"
import script from "./academic_itso_refereesystem.vue?vue&type=script&lang=js&"
export * from "./academic_itso_refereesystem.vue?vue&type=script&lang=js&"
import style0 from "./academic_itso_refereesystem.vue?vue&type=style&index=0&id=aca1e120&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca1e120",
  null
  
)

export default component.exports